import React from 'react';
import { useParams } from 'react-router-dom';
import Plyr from 'plyr-react';
import 'plyr-react/plyr.css';

function Season1Page() {
    const{id}=useParams();
  return (
    <div>
      <h2>Season1Page...</h2>
      <h3>{id} Серия..</h3>
        <Plyr
          source={{
            type: 'video',
            sources: [
              {
                src: `/serias/${id}`,
                type: 'video/mp4',
              },
            ],
          }}
        />
    </div>
  )
}

export default Season1Page;

